import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
  @Input() isOpen!: boolean;
  public outsideClickControl = false;

  @HostListener('document:click')
  clickOutside() {
    if (this.isOpen && !this.outsideClickControl) {
      this.toggle();
    }

    this.outsideClickControl = false;
  }

  public toggle() {
    this.isOpen = !!!this.isOpen;
    this.outsideClickControl = !this.outsideClickControl;
  }
}
